import React from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import "assets/scss/material-kit-react.scss?v=1.9.0";
import AuthLoading from "./components/AuthLoading";
import { Provider } from "react-redux";
import { store } from "./reducers/store";
import { fetchUser } from "./actions/authactions";
import { fetchCarTypes } from "./actions/cartypeactions";
import Home from "v2/views/home";
import Confirmation from "v2/views/confirmation";
import About from "v2/views/about";
import Contact from "v2/views/contact";

var hist = createBrowserHistory();

function App() {
  store.dispatch(fetchUser());
  store.dispatch(fetchCarTypes());
  return (
    <Provider store={store}>
      <AuthLoading>
        <Router history={hist}>
          <Switch>
            <Route path="/about" component={About} />
            <Route path="/contact" component={Contact} />
            <Route path="/confirmation" component={Confirmation} />
            <Route path="/" component={Home} />
          </Switch>
        </Router>
      </AuthLoading>
    </Provider>
  );
}

export default App;
